import Vue from 'vue';
import overview from '../../mixins/overview.js';
import transition_staggered_fade from '../../mixins/transition-staggered-fade-mixin.js';

Vue.component('overview-filter-block', {
    mixins: [overview, transition_staggered_fade],
    data: function() {
        return {
            loadItems: 999,
            currentCharacter: '',
            animToUse: 'staggered-fade'
        };
    },

    computed: {
        characterFilter: function() {
            return this.searchResults.reduce((characters, result) => {
                characters.indexOf(result.Title[0]) != -1
                    ? null
                    : characters.push(result.Title[0]);
                for (let i = 0; i < characters.length; i++) {
                    if (/\W/.test(characters[i])) {
                        characters.splice(i);
                    }
                }
                return characters.sort();
            }, []);
        },
        filteredResults: function() {
            if (this.currentCharacter != '') {
                return this.searchResults.filter(result => {
                    if (result.Title[0].match(/\W/gm)) {
                        return (
                            result.Title[1].toLowerCase() ==
                            this.currentCharacter.toLowerCase()
                        );
                    }
                    return (
                        result.Title[0].toLowerCase() ==
                        this.currentCharacter.toLowerCase()
                    );
                });
            }
            return this.searchResults;
        }
    },

    methods: {
        setCharFilter: function(char) {
            if (this.currentCharacter == char) {
                this.currentCharacter = '';
            } else {
                this.currentCharacter = char;
            }
        }
    }
});
